import React, { useEffect } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseInsuranceEnrolPage.module.scss'

import useInsuranceRegister from '@Hooks/myhouse/insurance/useInsuranceRegister'
import MyhouseInsuranceHeader from '@Components/atoms/MyhouseInsuranceHeader'
import MyhouseInsuranceSelectBox from '@Components/atoms/MyhouseInsuranceSelectBox'
import BlindContent from '@Components/VAC/common/BlindContent'
import useToast from '@Hooks/myhouse/useToast'
import useDebounce from '@Hooks/common/useDebounce'
import useInsurance from '@Hooks/myhouse/insurance/useInsurance'

const cx = className.bind(style)

const MyhouseInsuranceEnrolPage: React.FC = () => {
  const history = useHistory()
  const { show } = useToast()
  const { landDebounce } = useDebounce()
  const { insurance } = useInsurance()
  const { insuranceRegister, loadInsuranceRegister, setInitialState } = useInsuranceRegister()

  const debouncedLoadInsuranceRegister = landDebounce(loadInsuranceRegister)

  useEffect(() => {
    return () => {
      setInitialState()
    }
  }, [])

  useEffect(() => {
    if (insuranceRegister.isSuccess) {
      // open(insuranceRegister.modalType)
      show('보험 정보가 등록되었습니다.')
      history.goBack()
    }
  }, [insuranceRegister.isSuccess])

  const handleRegisterInsurance = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()

    if (insuranceRegister.isPending) {
      return
    }

    const isValidation = !!insuranceRegister.companyCode && !!insuranceRegister.productSequence && !!insuranceRegister.startYearMonth

    if (!isValidation) {
      show('모든 정보를 입력해 주세요.')
      return
    }

    const param = {
      houseNo: insuranceRegister.houseNo,
      productSequence: insuranceRegister.productSequence,
      startYM: insuranceRegister.startYearMonth,
      subscriptionPeriod: insuranceRegister.subscriptionPeriod,
    }

    debouncedLoadInsuranceRegister(param)
  }
  return (
    <>
      <MyhouseInsuranceHeader isEnrol={true} />

      <section id="content" className={cx('content_myhouse', 'type_enrollment')} role="main">
        <BlindContent />

        <div className={cx('content_enrollment_inner')}>
          <div className={cx('myhouse_insurance_head')}>
            <strong className={cx('myhouse_head_title')}>{insuranceRegister.houseLabel}</strong>
            <p className={cx('myhouse_head_text', 'type_basic')}>우리집 보험 가입 정보를 입력하면 만료월 알림을 받아보거나 긴급시에 손쉽게 보험사에 연락할 수 있습니다.</p>
          </div>

          <div className={cx('myhouse_insurance_list', 'type_select')}>
            <MyhouseInsuranceSelectBox insuranceCompanies={insurance.insuranceSelectBox.insuranceCompanies} insuranceProducts={insurance.insuranceSelectBox.insuranceProducts} />
          </div>

          <div className={cx('myhouse_insurance_date')}>
            <div className={cx('myhouse_date_expect')}>
              <dl className={cx('myhouse_expect_description')}>
                <dt className={cx('myhouse_description_title')}>보험만료 예상 연월</dt>
                <dd className={cx('myhouse_description_data')}>
                  <strong className={cx('myhouse_data_emphasis')}>{insuranceRegister.endYearMonthText}</strong>
                </dd>
              </dl>
            </div>
            <p className={cx('myhouse_date_text', 'type_basic')}>가입기간을 기준으로 자동 계산합니다.</p>
          </div>
        </div>

        <div className={cx('myhouse_enrollment_confirm')}>
          <button className={cx('myhouse_confirm_button', 'type_confirm')} type="button" onClick={(e) => handleRegisterInsurance(e)}>
            등록하기
          </button>
        </div>
      </section>
    </>
  )
}

export default MyhouseInsuranceEnrolPage
